module.exports = __webpack_public_path__ + "img/catalogued_until_now.f4cd8570.jpg";